var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":"","target":"_blank","href":_vm.href}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }